import { toast } from 'react-hot-toast';

import type { RouterOutputs } from '@poseidon/api/types';

type MessagesSendObj = RouterOutputs['messagingTypes']['sendTypes'];

export function sendPostMessage<K extends keyof MessagesSendObj>(
  type: K,
  data: MessagesSendObj[K] extends never ? undefined : MessagesSendObj[K],
) {
  if (window.parent) {
    window.parent.postMessage({ type, data }, '*');
  } else {
    toast.error('An error has occurred');
  }
}
